import { render, staticRenderFns } from "./BonusPointPay.vue?vue&type=template&id=dfef484e&scoped=true"
import script from "./BonusPointPay.vue?vue&type=script&lang=js"
export * from "./BonusPointPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfef484e",
  null
  
)

export default component.exports